import React from 'react';

import ClearIcon from 'ravenjs/lib/SvgIcon/types/ClearIcon';
import { Toaster as DefaultToaster } from 'ravenjs/lib/Toaster';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const commonStyles = {
    color: MIGRATED_COLORS.white,
    margin: '0.625rem',
    minHeight: '48px',
    borderRadius: '8px',
    padding: '0.75rem 1rem 0.75rem 1rem',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontFamily: 'Roboto',
    fontWeight: '400',
    lineHeight: '1.438rem',
    boxShadow: `0 2px 6px 0 ${MIGRATED_COLORS.literalRgba22322322305}`,
    backgroundColor: MIGRATED_COLORS.white,
    border: `solid 1px ${MIGRATED_COLORS.lighter}`,
    alignItems: 'center',
    justifyContent: 'center',
};
const defaultStyles = {
    borderLeft: `solid 16px ${MIGRATED_COLORS.green}`,
};
const errorStyles = {
    backgroundColor: MIGRATED_COLORS.red,
};
const successStyles = {
    backgroundColor: MIGRATED_COLORS.green3,
};
const warningStyles = {
    backgroundColor: MIGRATED_COLORS.yellow,
    color: MIGRATED_COLORS.black,
};
const infoStyles = {
    backgroundColor: MIGRATED_COLORS.blue4,
    color: MIGRATED_COLORS.black,
};

const Toaster = props => {
    const closeButton = ({ closeToast }) => (
        <ClearIcon margin="5px 0.5rem 2px 0.5rem" onClick={closeToast} />
    );

    return (
        <DefaultToaster
            closeButton={closeButton}
            closeOnClick={false}
            commonStyles={commonStyles}
            errorStyles={errorStyles}
            successStyles={successStyles}
            warningStyles={warningStyles}
            defaultStyles={defaultStyles}
            infoStyles={infoStyles}
            position="bottom-left"
            {...props}
        />
    );
};

export default Toaster;
